'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var Select = require('./Select');
var Input = require('./Input');
var InputGroup = require('./InputGroup');
var FormField = require('./FormField');
var Mixin = require('../mixin');

var SelectableInput = (function (_React$Component) {
    _inherits(SelectableInput, _React$Component);

    function SelectableInput(props) {
        _classCallCheck(this, SelectableInput);

        _get(Object.getPrototypeOf(SelectableInput.prototype), 'constructor', this).call(this, props);
        this.displayName = 'SelectableInput';
    }

    _createClass(SelectableInput, [{
        key: 'getField',
        value: function getField(fieldName) {
            var fields = this.props.fields,
                field = { name: '' };
            if (!!fields) {
                for (var i = 0; i < fields.length; i++) {
                    if (fieldName === fields[i].name) {
                        return fields[i];
                    }
                }
            }
            return field;
        }
    }, {
        key: 'getFieldsAndValues',
        value: function getFieldsAndValues() {
            var fields = this.props.fields,
                fieldsAndValues = {};
            if (fields) {
                fields.forEach(function (field) {
                    fieldsAndValues[field.name] = field.value;
                });
            }
            return fieldsAndValues;
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            var fields = this.props.fields,
                options = [];
            if (fields) {
                fields.forEach(function (field) {
                    options.push({
                        label: field.label,
                        value: field.name
                    });
                });
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            //TODO: Read only has to be updated. Check with UED team.
            if (this.props.readOnly) {
                var fields = this.props.fields;
                if (fields) {
                    var component = [];
                    fields.forEach(function (field, index) {
                        component.push(_react2['default'].createElement(Input, {
                            key: 'label' + index,
                            id: this.props.id,
                            readOnly: true,
                            value: field.label + ' : ' + field.value }));
                    });

                    return _react2['default'].createElement(
                        'div',
                        null,
                        component
                    );
                } else {
                    return false;
                }
            } else {
                var field = this.getField(this.props.field),
                    options = this.getOptions();
                return _react2['default'].createElement(
                    InputGroup,
                    { contiguous: true, id: this.props.id },
                    _react2['default'].createElement(
                        InputGroup.Section,
                        null,
                        _react2['default'].createElement(Select, {
                            options: options,
                            label: this.props.label,
                            value: field.name,
                            placeholder: this.props.placeholder,
                            onChange: this._onSelectChange.bind(this) }),
                        _react2['default'].createElement(Input, {
                            type: 'text',
                            value: field.value,
                            label: field.label,
                            disabled: field.name === '',
                            errors: this.props.errors,
                            onChange: this._onInputChange.bind(this) })
                    )
                );
            }
        }
    }, {
        key: '_onSelectChange',
        value: function _onSelectChange(value) {
            //Reset all field's value.
            var fieldsAndValues = this.getFieldsAndValues();
            Object.keys(fieldsAndValues).forEach(function (key) {
                fieldsAndValues[key] = '';
            });

            var output = {
                field: value,
                fields: fieldsAndValues
            };

            this.props.onChange(output);
        }
    }, {
        key: '_onInputChange',
        value: function _onInputChange(value) {
            var fieldsAndValues = this.getFieldsAndValues();
            fieldsAndValues[this.props.field] = value;

            var output = {
                field: this.props.field,
                fields: fieldsAndValues
            };

            this.props.onChange(output);
        }
    }]);

    return SelectableInput;
})(_react2['default'].Component);

SelectableInput.propTypes = {
    label: _propTypes2['default'].string,
    placeholder: _propTypes2['default'].string.isRequired,
    readOnly: _propTypes2['default'].bool,
    value: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func.isRequired,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    field: _propTypes2['default'].string,
    id: _propTypes2['default'].string,

    fields: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        name: _propTypes2['default'].string.isRequired,
        label: _propTypes2['default'].string.isRequired,
        value: _propTypes2['default'].string.isRequired
    })).isRequired
};

(0, _reactMixin2['default'])(SelectableInput.prototype, Mixin);

module.exports = SelectableInput;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/SelectableInput.js
// module id = 981
// module chunks = 0 1